var map = {
	"./games/a-la-cama": 33,
	"./games/a-la-cama.json": 33,
	"./games/administrathor": 34,
	"./games/administrathor.json": 34,
	"./games/amish-paradise": 35,
	"./games/amish-paradise.json": 35,
	"./games/atalanta-golden-odyssey": 36,
	"./games/atalanta-golden-odyssey.json": 36,
	"./games/black-friday-cart-race": 37,
	"./games/black-friday-cart-race.json": 37,
	"./games/bubble-bind": 38,
	"./games/bubble-bind.json": 38,
	"./games/cinco-etapas": 39,
	"./games/cinco-etapas.json": 39,
	"./games/contando-hasta-100": 40,
	"./games/contando-hasta-100.json": 40,
	"./games/conway": 41,
	"./games/conway.json": 41,
	"./games/duof": 42,
	"./games/duof.json": 42,
	"./games/elf-hunting": 43,
	"./games/elf-hunting.json": 43,
	"./games/escupitajulus-insanis": 44,
	"./games/escupitajulus-insanis.json": 44,
	"./games/fosu": 45,
	"./games/fosu.json": 45,
	"./games/games": 15,
	"./games/games.json": 15,
	"./games/greedy-atm": 46,
	"./games/greedy-atm.json": 46,
	"./games/hold-it": 47,
	"./games/hold-it.json": 47,
	"./games/identity-thief": 48,
	"./games/identity-thief.json": 48,
	"./games/info-harvest": 49,
	"./games/info-harvest.json": 49,
	"./games/jdb": 50,
	"./games/jdb.json": 50,
	"./games/la-kolektanto": 51,
	"./games/la-kolektanto.json": 51,
	"./games/one-of-you-is-a-magical-dog": 52,
	"./games/one-of-you-is-a-magical-dog.json": 52,
	"./games/piratinsul": 53,
	"./games/piratinsul.json": 53,
	"./games/pongmoi": 54,
	"./games/pongmoi.json": 54,
	"./games/rgb-pong": 55,
	"./games/rgb-pong.json": 55,
	"./games/snakejs": 56,
	"./games/snakejs.json": 56,
	"./games/superuatakku": 57,
	"./games/superuatakku.json": 57,
	"./games/tags": 21,
	"./games/tags.json": 21,
	"./games/tiny-revolution": 58,
	"./games/tiny-revolution.json": 58,
	"./games/tirando-cable": 59,
	"./games/tirando-cable.json": 59,
	"./games/ufo-taxi": 60,
	"./games/ufo-taxi.json": 60,
	"./games/zero-gravity-delivery": 61,
	"./games/zero-gravity-delivery.json": 61,
	"./home/home": 16,
	"./home/home.json": 16,
	"./literature": 10,
	"./literature/": 10,
	"./literature/cuarto-poder": 62,
	"./literature/cuarto-poder.json": 62,
	"./literature/de-visita": 63,
	"./literature/de-visita.json": 63,
	"./literature/el-chico": 64,
	"./literature/el-chico.json": 64,
	"./literature/el-cocinero": 65,
	"./literature/el-cocinero.json": 65,
	"./literature/el-elemental": 66,
	"./literature/el-elemental.json": 66,
	"./literature/el-heroe": 67,
	"./literature/el-heroe.json": 67,
	"./literature/el-sueño": 68,
	"./literature/el-sueño.json": 68,
	"./literature/fragmentos-de-vida": 69,
	"./literature/fragmentos-de-vida.json": 69,
	"./literature/index": 10,
	"./literature/index.json": 10,
	"./literature/la-chica-de-la-parada": 70,
	"./literature/la-chica-de-la-parada.json": 70,
	"./literature/la-ejecucion": 71,
	"./literature/la-ejecucion.json": 71,
	"./literature/la-escultora": 72,
	"./literature/la-escultora.json": 72,
	"./literature/la-presencia": 73,
	"./literature/la-presencia.json": 73,
	"./literature/microrelatos": 74,
	"./literature/microrelatos.json": 74,
	"./literature/nervo": 75,
	"./literature/nervo.json": 75,
	"./literature/patentes-y-ruedas": 76,
	"./literature/patentes-y-ruedas.json": 76,
	"./literature/tags": 22,
	"./literature/tags.json": 22,
	"./locale/es_ES": 20,
	"./locale/es_ES.json": 20,
	"./software": 11,
	"./software/": 11,
	"./software/como": 77,
	"./software/como.json": 77,
	"./software/index": 11,
	"./software/index.json": 11,
	"./software/manuskript-global-search": 78,
	"./software/manuskript-global-search.json": 78,
	"./software/rap": 79,
	"./software/rap.json": 79,
	"./software/tags": 23,
	"./software/tags.json": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;